import getDoctorPlaceTypes from './getDoctorPlaceTypes'

describe('getDoctorPlaceTypes', () => {
  describe('Когда есть цены клиники, дома и телемеда', () => {
    test('Тогда возвращаются все три типа приёма', () => {
      expect(getDoctorPlaceTypes({
        tab_min_price: 1500,
        tab_min_price_go: 3000,
        tab_min_price_telemed: 2000,
      })).toEqual(['clinic', 'home', 'telemed'])
    })
  })

  describe('Когда цен нет', () => {
    test('Тогда список типов пустой', () => {
      expect(getDoctorPlaceTypes(null)).toEqual([])
    })
  })

  describe('Когда цена клиники ноль', () => {
    test('Тогда тип clinic всё равно есть', () => {
      expect(getDoctorPlaceTypes({ tab_min_price: 0 })).toEqual(['clinic'])
    })
  })
})
